// Module
var code = `<div class="card-expanded-holder"></div>

<div class="page-header">
  <figure class="bg-image">
    <img src="{{bgImg}}" alt="{{alt}}" />
  </figure>

  <div class="callout">
    <header>
      <h1>{{headline}} HEADLINE</h1>
      <p>Minim laoreet ad mei, volumus invenire elaboraret has ut.</p>
    </header>
  </div>
</div>

<div class="page-content default-content">
  <header>
    <h2>Learn more about {{headline}}</h2>
    <p>{{text}}</p>
  </header>
  <ul
    class="app-page-subnav-container subnav-items-{{contentLen}}"
    aria-label="cards"
  ></ul>
</div>
`;
// Exports
module.exports = code;